export default {
  header: {
    lema: "...with Marist identity",
    recursos: "Resources",
    contacto: "Contact",
    buscar: "Search illustrations...",
    limpiar: "Clear search",
  },
  hamburguesa: {
    recursos: "Resources",
    filtros: "Filters",
    favoritos: "Favorites",
    presentacion: "About",
    contacto: "Contact",
  },
  welcome: {
    title: "Graphic resources with Marist identity",
    p1: "An open repository of illustrations and designs for pastoral, education, and community.",
    p2: "All free, downloadable, and free to use.",
    p3: "This is <strong>Marist-Art</strong>. Nothing complicated (I hope): an open repository of <strong>illustrations and designs for pastoral care, education and community</strong>. You have filters, search, and the option to bookmark favorites.\n\nAll free, downloadable and free for non-commercial use. Also some interesting links below.\n\nIf you want to comment or have suggestions, feel free to write. <strong>Welcome</strong> everyone.",
    button: "Browse resources",
  },
  filtros: {
    label: "Filters",
    allFilters: "+ All filters",
    mobileFilters: "+ Filters",
    results: "result",
    results_plural: "results",
    temas: "Themes",
    tags: "Tags",
    usos: "Uses",
    tintas: "Inks",
    limpiar: "clear",
  labels: {
    temas: {
  champagnat: "Champagnat",
  maria: "Mary",
  jesus: "Jesus",
  educacion: "education",
  social: "social",
  deporte: "sports",
  naturaleza: "nature",
  tiempos_liturgicos: "liturgical seasons",
  evangelio: "gospel",
  paz: "peace",
  infantil: "children",
  violetas: "violets",
  vocacional: "vocational",
  hermitage: "Hermitage",
  gvx: "GVX",
  maristas: "marists",
},
    tags: {
      firma: "signature",
      frase: "phrase",
      logo: "logo",
      minimalista: "minimalist",
      sin_fondo: "no background",
    },
    usos: {
      cartel: "poster",
      colorear: "coloring",
      mural: "mural",
      postal: "postcard",
      rrss: "social media",
      sticker: "sticker",
      taza: "mug",
      textil: "textile",
    },
    tintas: {
      monocolor: "1 ink",
      bicolor: "2 inks",
      blanco_negro: "B&W",
      escala_grises: "grayscale",
      multicolor: "multicolor",
    },
  },
},
  favoritos: {
    confirmDelete: "Delete all favorites?",
    cancelar: "Cancel",
    borrar: "Delete",
  },
  lightbox: {
    descargar: "Download",
    original: "Original",
    adaptado: "Adapted",
    de: "From:",
    cerrar: "Close",
    anterior: "Previous",
    siguiente: "Next",
  },
  infopanels: {
    aboutTitle: "About & Legal Notice",
    aboutText: `My name is Arturo Morales Pérez. I am a Marist of Champagnat lay and a member of the Marist Mediterranean Province.

In addition to my usual work (educator and catechist), I often create designs and illustrations, or adapt them to digital format, for our pastoral, educational, vocational, social, and community activities.

This website/pwa has a simple purpose: to serve as a repository of images I have created or vectorized, related to those purposes. It includes adaptations of drawings or illustrations found online or shared with me. In those cases, "adapted" will appear in the title and, whenever possible, the author of the original image or fragment will be credited. C_Towers deserves a special mention; he is a friend and a natural-born artist with a brush and crayons.

It is therefore not an online design studio, or marketing website, nor a personal artist page. All content is shared under a Creative Commons BY-NC 4.0 license. See the legal notice for more details.

Glad to have you here.`,
    contactTitle: "Inquiries & Contact",
    contactText: "If you have any questions, inquiries, or contributions, you can do so here. Your data will only be used for this purpose.",
    emailPlaceholder: "Your email",
    messagePlaceholder: "Message",
    send: "Send",
    sending: "Sending...",
    sent: "✔ Message sent successfully",
    avisoLegal: "Legal notice",
  },
  footer: {
    avisoLegal: "Legal notice",
    cc: "CC BY-NC 4.0",
  },
  grid: {
    noResults: "No results. Try adjusting filters or search.",
  },
};